import { CUSTOM_ELEMENTS_SCHEMA, NgModule, Type } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PipesModule } from '../pipes/pipes.module';
import { DirectivesModule } from '../directives/directives.module';
import { AssignmentsApp } from './assignments.app';
import { AssignmentListComponent } from './overview/list/assignment-list.component';
import { AssignmentMapComponent } from './overview/map/assignment-map.component';
import { AssignmentOverviewComponent } from './overview/assignment-overview.component';
import { TimelineComponent } from './overview/map/timeline/timeline.component';
import { WorkplanComponent } from './overview/map/workplan/workplan.component';
import { WorkPlanMapComponent } from './overview/map/work-plan-map/work-plan-map.component';
import { AssignmentListItemComponent } from './overview/map/workplan/assignment-list-item/assignment-list-item.component';
import { AssignmentListRowComponent } from './overview/list/assignment-list-row.component';
import { AssignmentEditorModule } from '../assignment-editor/assignment-editor.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PostponePlanDialogComponent } from './postpone-plan-dialog/postpone-plan-dialog.component';
import { DialogModule } from '../dialog/dialog.module';
import { DownloadWorksheetDialogComponent } from './download-worksheet-dialog/download-worksheet-dialog.component';
import { AssignmentPreviewDialogComponent } from './assignment-preview-dialog/assignment-preview-dialog.component';
import { EditRecurringAssignmentDialogComponent } from './edit-recurring-assignment-dialog/edit-recurring-assignment-dialog.component';
import { ShiftSummaryComponent } from './overview/map/shift-summary/shift-summary.component';
import { DownloadInvoicesDialogComponent } from './download-invoices-dialog/download-invoices-dialog.component';
import { MoveAssignmentsDialogComponent } from './move-assignments-dialog/move-assignments-dialog.component';
import { VideoModule } from '../video/video.module';
import { FeedbackModule } from '../feedback/feedback.module';
import { FeatureIntroductionModule } from '../feature-introduction/feature-introduction.module';

@NgModule({
    declarations: [
        AssignmentsApp,
        AssignmentListComponent,
        AssignmentListRowComponent,
        AssignmentOverviewComponent,
        AssignmentMapComponent,
        TimelineComponent,
        WorkplanComponent,
        WorkPlanMapComponent,
        AssignmentListItemComponent,
        PostponePlanDialogComponent,
        DownloadWorksheetDialogComponent,
        AssignmentPreviewDialogComponent,
        EditRecurringAssignmentDialogComponent,
        ShiftSummaryComponent,
        DownloadInvoicesDialogComponent,
        MoveAssignmentsDialogComponent
    ],
    imports: [
        CommonModule,
        FeedbackModule,
        PipesModule,
        DirectivesModule,
        AssignmentEditorModule,
        FormsModule, // Why do we need to specify form here when it is already in AssignmentEditorModule?
        ReactiveFormsModule, 
        DialogModule, 
        VideoModule,
        FeatureIntroductionModule
    ],
    exports: [
        AssignmentsApp,
        AssignmentListComponent,
        AssignmentOverviewComponent,
        AssignmentMapComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AssignmentsModule {
  customElementComponent: Type<any> = AssignmentsApp;

  constructor() {}

  ngDoBootstrap() { }
}
